import React from 'react';
import ReceiveItem from '../ReceiveItem';

const ReceiveList = (props) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  const { data, selected, onSelect } = props;
  /* ===== State ===== */
  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /* ===== Render ===== */
  return (
    <ul
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
      }}
    >
      {data?.receive_ids?.map((receive) => {
        const isChecked =
          selected?.forwarding_location_id === receive?.forwarding_location_id;

        return (
          <ReceiveItem
            item={receive}
            selected={isChecked}
            onSelect={onSelect}
          />
        );
      })}
    </ul>
  );
};

export default ReceiveList;
